const BASE = process.env.REACT_APP_API_URL;

export default function concatURL(path) {
  let slash = path.startsWith('/') ? '' : '/';
  return `${BASE}${slash}${path}`;
}
